import React, { useRef, useState, useEffect } from 'react'
import Logo from "../Images/newlogo.svg"
import { Link } from 'react-router-dom'
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from 'react-bootstrap/Spinner';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { app } from "../firebase.js"
import swal from 'sweetalert';
import { doc, setDoc, getFirestore } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { useLocation } from '../Components/LocationContext';

import InputGroup from 'react-bootstrap/InputGroup';
import kenyaImg from '../Images/kenyaflag.png'
import ugandaImg from "../Images/ugandaflag.svg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEye,
  faEyeSlash
} from '@fortawesome/free-solid-svg-icons'


function Register() {

  const userNameRef = useRef();
  const userTypeRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();

  const auth = getAuth();
  const db = getFirestore(app);
  const navigate = useNavigate();

  const [signUpBtn, setSignUpbtn] = useState(true)
  const [loadingBtn, setLoadingBtn] = useState(false)

  const { location, currency } = useLocation();

  const [phone, setPhone] = useState("");
  const [countryLogo, setCountryLogo] = useState(kenyaImg);
  const [country, setCountry] = useState("kenya");

  const [showPassword, setShowPassword] = useState(false)
  const [userType, setUserType] = useState("A user")



  useEffect(() => {
    setCountryLogo(country === "uganda" ? ugandaImg : kenyaImg);
  }, [country]);

  // ====== SEO & Meta Tags ======
  useEffect(() => {
    document.title = "Zindua App | Sign Up";

    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", "Sign up for Zindua App to create a creator account or connect with influencers for your brand campaigns.");

    const ogTags = [
      { property: "og:title", content: "Zindua App | Sign Up" },
      { property: "og:description", content: "Sign up for Zindua App to create a creator account or connect with influencers for your brand campaigns." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/register" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Zindua",
      url: "https://zindua.app",
      logo: "https://zindua.app/logo192.png",
      sameAs: [
        "https://www.instagram.com/zindua.app/",
        "https://www.linkedin.com/company/zindua-app/",
        "https://www.tiktok.com/@zindua.app"
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+254795156925",
        contactType: "customer support",
        email: "hello@zindua.app"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);


  function signUpUser() {
    //getting data from form input 
    const username = userNameRef.current.value;
    const userType = userTypeRef.current.value;
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const timestamp = new Date();

    if (!username || !userType || !email || !password || !phone) {
      swal("Error", "Fill all fields", "error");
      return;
    }

    if (phone.length < 10) {
      swal("Error", "Phone number must be at least 10 digits", "error");
      return;
    }

    setSignUpbtn(false);
    setLoadingBtn(true);

    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCreds) => {
        const userId = userCreds.user.uid;

        // reserve username first
        await setDoc(doc(db, "usernames", userId), {
          uid: userId
        });

        // create user profile
        await setDoc(doc(db, "users", userId), {
          userName: username,
          userType: userType,
          email: email,
          userId: userId,
          timestamp: timestamp,
          theUsername: userId,
          city: location.city,
          country: country,
          region: location.region,
          userLat: location.userLat,
          userLng: location.userLng,
          currencyCode: currency.code,
          countryName: currency.countryName,
          currencyName: currency.name,
          currencySymbol: currency.symbol,
          countryFlag: currency.flag,
          selectedCountry: country,
          ipCountry: location.country,
          mpesaNumber: phone,
          accountIsVerified: false,
          acceptingAds: true,
          acceptingSubs: true,
          isPhoneVerified:true
        });

        sendWelcomeSms(phone, userType);
        sendWelcomeEmail(email, userType, username);

        navigate(
          userType === "An Influencer"
            ? "/edit-profile"
            : "/user/dashboard"
        );
      })
      .catch((error) => {
        setSignUpbtn(true);
        setLoadingBtn(false);

        const cleanMessage = error.message
          .replace("Firebase: Error (auth/", "")
          .replace(").", "")
          .replace(/-/g, " ")
          .toLowerCase()
          .replace(/^\w/, c => c.toUpperCase())

        swal("Sign Up error", cleanMessage, "error")
      });

  }

  async function sendWelcomeSms(phoneNumber, userType) {
    try {
      const token = await auth.currentUser.getIdToken()

      const message =
        userType === "An Influencer"
          ? "Welcome to Zindua App. Your creator account is ready. Complete your profile to start receiving ads and subscriptions."
          : "Welcome to Zindua App. Find the right Influencer for your brand and campaigns within your budget on your favourite platforms."

      await fetch(
        "https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            phoneNumber,
            message
          })
        }
      )


    } catch (err) {
      console.error("Welcome SMS failed", err)
    }
  }

  async function sendWelcomeEmail(email, userType, userName) {
    try {
      const token = await auth.currentUser.getIdToken()

      const isInfluencer = userType === "An Influencer"

      const subject = isInfluencer
        ? "WELCOME TO ZINDUA. YOUR CREATOR ACCOUNT IS READY"
        : "WELCOME TO ZINDUA. LET US GROW YOUR BRAND"

      const message = isInfluencer
        ? `
        <div style="background:#f6f7f9;padding:40px 0;">
          <div style="max-width:560px;margin:0 auto;background:#ffffff;border-radius:8px;padding:32px;font-family:Arial,sans-serif;color:#111;">

            <h2 style="margin:0 0 16px;font-size:20px;">Hello ${userName}</h2>

            <p style="font-size:14px;margin:0 0 16px;">
              Welcome to Zindua. A platform built to help creators earn in a clear and controlled way.
            </p>

            <h3 style="font-size:16px;margin:24px 0 8px;">How Zindua works for you</h3>

            <p style="font-size:14px;margin:0 0 6px;">• You create a creator profile</p>
            <p style="font-size:14px;margin:0 0 6px;">• You showcase your platforms, audience, and content style</p>
            <p style="font-size:14px;margin:0 0 16px;">• You choose ads, subscriptions, or both</p>

            <h3 style="font-size:16px;margin:24px 0 8px;">Ads</h3>

            <p style="font-size:14px;margin:0 0 6px;">• Brands send ad requests directly to you</p>
            <p style="font-size:14px;margin:0 0 6px;">• You review and accept or decline</p>
            <p style="font-size:14px;margin:0 0 16px;">• You deliver content and get paid</p>

            <h3 style="font-size:16px;margin:24px 0 8px;">Subscriptions</h3>

            <p style="font-size:14px;margin:0 0 6px;">• Enable monthly subscriptions</p>
            <p style="font-size:14px;margin:0 0 6px;">• Followers support your work</p>
            <p style="font-size:14px;margin:0 0 16px;">• Earn recurring income</p>

            <h3 style="font-size:16px;margin:24px 0 8px;">Next steps</h3>

            <p style="font-size:14px;margin:0 0 6px;">• Complete your profile</p>
            <p style="font-size:14px;margin:0 0 6px;">• Verify your account</p>
            <p style="font-size:14px;margin:0 0 20px;">• Start receiving ads and subscriptions</p>

            <a href="https://zindua.app/login"
              style="display:inline-block;background:#000;color:#fff;text-decoration:none;padding:12px 20px;border-radius:4px;font-size:14px;">
              Log in to Zindua
            </a>

            <div style="margin-top:32px;font-size:13px;color:#555;">
              <p style="margin:0;">Reinhard Omukuba</p>
              <p style="margin:0;">CTO</p>
              <p style="margin:0;">Zindua App</p>
            </div>

          </div>
        </div>

      `
        : `
        <div style="background:#f6f7f9;padding:40px 0;">
        <div style="max-width:560px;margin:0 auto;background:#ffffff;border-radius:8px;padding:32px;font-family:Arial,sans-serif;color:#111;">

          <h2 style="margin:0 0 16px;font-size:20px;">Hello ${userName}</h2>

          <p style="font-size:14px;margin:0 0 16px;">
            Welcome to Zindua. A simple way to work directly with creators.
          </p>

          <h3 style="font-size:16px;margin:24px 0 8px;">How Zindua works for you</h3>

          <p style="font-size:14px;margin:0 0 6px;">• Discover verified creators</p>
          <p style="font-size:14px;margin:0 0 6px;">• View pricing, platforms, and audience type</p>
          <p style="font-size:14px;margin:0 0 16px;">• Choose creators that match your goals</p>

          <h3 style="font-size:16px;margin:24px 0 8px;">Running ads</h3>

          <p style="font-size:14px;margin:0 0 6px;">• Submit an ad request</p>
          <p style="font-size:14px;margin:0 0 6px;">• Agree on pricing and timelines</p>
          <p style="font-size:14px;margin:0 0 16px;">• Receive delivered content</p>

          <h3 style="font-size:16px;margin:24px 0 8px;">Payments</h3>

          <p style="font-size:14px;margin:0 0 6px;">• Pay only after acceptance</p>
          <p style="font-size:14px;margin:0 0 6px;">• Clear and transparent pricing</p>
          <p style="font-size:14px;margin:0 0 16px;">• No hidden charges</p>

          <h3 style="font-size:16px;margin:24px 0 8px;">Next steps</h3>

          <p style="font-size:14px;margin:0 0 6px;">• Explore creators</p>
          <p style="font-size:14px;margin:0 0 6px;">• Submit your first ad request</p>
          <p style="font-size:14px;margin:0 0 20px;">• Launch your campaign</p>

          <a href="https://zindua.app/login"
            style="display:inline-block;background:#000;color:#fff;text-decoration:none;padding:12px 20px;border-radius:4px;font-size:14px;">
            Log in to Zindua
          </a>

          <div style="margin-top:32px;font-size:13px;color:#555;">
            <p style="margin:0;">Reinhard Omukuba</p>
            <p style="margin:0;">CTO</p>
            <p style="margin:0;">Zindua App</p>
          </div>

        </div>
      </div>
      `

      await fetch(
        "https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            email,
            subject,
            message
          })
        }
      )
    } catch (err) {
      console.error("Welcome email failed", err)
    }
  }


  return (
    <div className='authPage'>
      <div className='authLeft'>
        <div className='authLeftBg'></div>
      </div>

      <div className='authRight'>
        <div className='authRightcont'>
          <Link to="/" className='authRightLogo'>
            <img src={Logo} alt="" />
          </Link>

          {/* <h1>Sign Up</h1> */}

          <Form.Group className="mt-3">
            <Form.Label>Signing up as a</Form.Label>
            <Form.Select
              ref={userTypeRef}
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="A user">User / Business</option>
              <option value="An Influencer">Creator / Influencer</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mt-3">
            {/* <Form.Label>Full Name / Business Name</Form.Label> */}
            <Form.Control
              type="text"
              placeholder={
                userType === "An Influencer"
                  ? "Creator or brand name"
                  : "Full name or business name"
              }
              ref={userNameRef}
            />
          </Form.Group>

          <InputGroup className="mt-3">
            <Form.Select
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              style={{ maxWidth: "120px" }}
            >
              <option value="kenya">Kenya</option>
              <option value="uganda">Uganda</option>
            </Form.Select>

            <InputGroup.Text id="basic-addon1" className="countryIconCont">
              <img src={countryLogo} className="countryIcon" alt="" />
            </InputGroup.Text>

            <Form.Control
              type="number"
              placeholder="07XXXXXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </InputGroup>


          <Form.Group className="mt-3">
            {/* <Form.Label>Email Address</Form.Label> */}
            <Form.Control
              type="email"
              placeholder="email"
              ref={emailRef}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="password"
                ref={passwordRef}
              />

              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                />
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>


          <br />

          <p className='authTos'>By signing up, you agree to the <Link to="/terms-of-service">Terms of Service</Link> and the <Link to="/privacy-policy">Privacy Policy</Link></p>

          <div className='bottomBtnCont'>
            {signUpBtn &&
              <Button variant="primary" onClick={signUpUser} className="mt-3 btnLogin w-100" >Sign Up</Button>
            }
            {loadingBtn && <Button variant="primary" disabled className='mt-3 btnLogin w-100'>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              {" "}Signing Up...
            </Button>
            }
            <Link to="/login">Already Have an Account? Sign In</Link>
          </div>

        </div>



      </div>
    </div>
  )
}

export default Register